"use client";

// packages/react/label/src/Label.tsx
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from "react";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx } from "react/jsx-runtime";
var NAME = "Label";
var Label = React.forwardRef(function (props, forwardedRef) {
  return /* @__PURE__ */jsx(Primitive.label, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef,
    onMouseDown: function onMouseDown(event) {
      var _props$onMouseDown;
      var target = event.target;
      if (target.closest("button, input, select, textarea")) return;
      (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 ? void 0 : _props$onMouseDown.call(props, event);
      if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
    }
  }));
});
Label.displayName = NAME;
var Root = Label;
export { Label, Root };